"use strict";

var _toConsumableArray = require("/Users/arjunjain/Borderless/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Mnemonic = require("bip39");

var passphraseRegularExpression = {
  uppercaseRegExp: /[A-Z]/g,
  whitespaceRegExp: /\s/g
};

exports.countPassphraseWhitespaces = function (passphrase) {
  var whitespaceMatches = passphrase.match(passphraseRegularExpression.whitespaceRegExp);
  return whitespaceMatches !== null ? whitespaceMatches.length : 0;
};

exports.countPassphraseWords = function (passphrase) {
  return passphrase.split(' ').filter(Boolean).length;
};

exports.countUppercaseCharacters = function (passphrase) {
  var uppercaseCharacterMatches = passphrase.match(passphraseRegularExpression.uppercaseRegExp);
  return uppercaseCharacterMatches !== null ? uppercaseCharacterMatches.length : 0;
};

exports.locateUppercaseCharacters = function (passphrase) {
  return passphrase.split('').reduce(function (upperCaseIndexes, character, index) {
    if (character.match(passphraseRegularExpression.uppercaseRegExp) !== null) {
      return [].concat(_toConsumableArray(upperCaseIndexes), [index]);
    }

    return upperCaseIndexes;
  }, []);
};

exports.locateConsecutiveWhitespaces = function (passphrase) {
  return passphrase.split('').reduce(function (whitespaceIndexes, character, index) {
    if (index === 0 && character.match(passphraseRegularExpression.whitespaceRegExp) !== null) {
      return [].concat(_toConsumableArray(whitespaceIndexes), [index]);
    }

    if (index !== passphrase.length - 1 && character.match(passphraseRegularExpression.whitespaceRegExp) !== null && passphrase.split('')[index - 1].match(passphraseRegularExpression.whitespaceRegExp) !== null) {
      return [].concat(_toConsumableArray(whitespaceIndexes), [index]);
    }

    if (index === passphrase.length - 1 && character.match(passphraseRegularExpression.whitespaceRegExp) !== null) {
      return [].concat(_toConsumableArray(whitespaceIndexes), [index]);
    }

    return whitespaceIndexes;
  }, []);
};

exports.getPassphraseValidationErrors = function (passphrase, wordlists) {
  var expectedWords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 12;
  var expectedWhitespaces = expectedWords - 1;
  var expectedUppercaseCharacterCount = 0;
  var wordsInPassphrase = exports.countPassphraseWords(passphrase);
  var whiteSpacesInPassphrase = exports.countPassphraseWhitespaces(passphrase);
  var uppercaseCharacterInPassphrase = exports.countUppercaseCharacters(passphrase);
  var passphraseWordError = {
    actual: wordsInPassphrase,
    code: 'INVALID_AMOUNT_OF_WORDS',
    expected: expectedWords,
    message: "Passphrase contains ".concat(wordsInPassphrase, " words instead of expected ").concat(expectedWords, ". Please check the passphrase.")
  };
  var whiteSpaceError = {
    actual: whiteSpacesInPassphrase,
    code: 'INVALID_AMOUNT_OF_WHITESPACES',
    expected: expectedWhitespaces,
    location: exports.locateConsecutiveWhitespaces(passphrase),
    message: "Passphrase contains ".concat(whiteSpacesInPassphrase, " whitespaces instead of expected ").concat(expectedWhitespaces, ". Please check the passphrase.")
  };
  var uppercaseCharacterError = {
    actual: uppercaseCharacterInPassphrase,
    code: 'INVALID_AMOUNT_OF_UPPERCASE_CHARACTER',
    expected: expectedUppercaseCharacterCount,
    location: exports.locateUppercaseCharacters(passphrase),
    message: "Passphrase contains ".concat(uppercaseCharacterInPassphrase, " uppercase character instead of expected ").concat(expectedUppercaseCharacterCount, ". Please check the passphrase.")
  };
  var validationError = {
    actual: false,
    code: 'INVALID_MNEMONIC',
    expected: true,
    message: 'Passphrase is not a valid mnemonic passphrase. Please check the passphrase.'
  };
  var finalWordList = wordlists !== undefined ? _toConsumableArray(wordlists) : Mnemonic.wordlists.english;
  return [passphraseWordError, whiteSpaceError, uppercaseCharacterError, validationError].reduce(function (errorArray, error) {
    if (error.code === passphraseWordError.code && wordsInPassphrase !== expectedWords) {
      return [].concat(_toConsumableArray(errorArray), [error]);
    }

    if (error.code === whiteSpaceError.code && whiteSpacesInPassphrase !== expectedWhitespaces) {
      return [].concat(_toConsumableArray(errorArray), [error]);
    }

    if (error.code === uppercaseCharacterError.code && uppercaseCharacterInPassphrase !== expectedUppercaseCharacterCount) {
      return [].concat(_toConsumableArray(errorArray), [error]);
    }

    if (error.code === validationError.code && !Mnemonic.validateMnemonic(passphrase, finalWordList)) {
      return [].concat(_toConsumableArray(errorArray), [error]);
    }

    return errorArray;
  }, []);
};